"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Banner = ({
  onClick,
  title,
  url
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.BANNER_CAROUSEL_BANNER),
    href: onClick ? undefined : url,
    onClick: onClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Title, {
      fontWeight: "bold",
      children: title
    })
  });
};
exports.Banner = Banner;
